export enum TransaccionEnum {
    EXITOSA,
    FALLIDA
}
